export enum ClientTrackingName {
    ChangeLanguage = 'change_language',
    Success = 'success',
    Error = 'error',
    Click = 'click',
    NotFound = 'not_found',
    ForgotDocuments = 'forgot_documents',
    DocumentExpired = 'document_expired',
    CouldNotMeetWorker = 'could_not_meet_worker',
    DocumentsNotGenuine = 'documents_not_genuine',
    IncorrectSection1OrSection2 = 'incorrect_section1_section2',
    Other = 'other'
}



// WEBPACK FOOTER //
// ./src/models/client-tracking-name.ts